import { ONE_MINUTE } from '@lucidlink/uicore';
export const WORKSPACE_DOMAIN_LIST_POLLING_INTERVAL = 5 * ONE_MINUTE; // 5 min
